import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useDueDatesApi } from "../../http/dueDates/api";
import { UpsertDueDate } from "../../http/dueDates/types";
import ModalDialog from "../ui/ModalDialog";
import DueDateFormNuovo, { DueDateFormBody } from "./DueDateForm";

interface CreateDueDateProps {
  carId?: string;
  onClose: (success?: boolean) => void;
}

const CreateDueDateDialog: FC<CreateDueDateProps> = ({ carId, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dueDatesApi = useDueDatesApi();

  const onSubmit = async (formData: DueDateFormBody) => {
    const body: UpsertDueDate = {
      carId: carId ?? formData.car.id,
      typeId: formData.type.id,
      date: formData.date,
      isSettled: formData.isSettled,
      visibleToUserId: formData.visibleToUser ? formData.driver?.id : undefined,
    };

    setIsSubmitting(true);
    try {
      await dueDatesApi.insertAdminDueDate(body);
      dispatch(showSuccessNotification(i18n.t));
      onClose(true);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog onClose={onClose} title={i18n.t.dueDates.new}>
      <DueDateFormNuovo isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} />
    </ModalDialog>
  );
};

export default CreateDueDateDialog;
